import { Seo } from "@/components/Seo";
import { Link } from "react-router-dom";
import { Trophy, Crown, Sparkles } from "lucide-react";

export default function PromCup() {
  return (
    <div data-testid="prom-cup-page" className="max-w-[1100px] mx-auto px-5 sm:px-8 pt-16 text-center">
      <Seo title="The Prom Cup — Statewide School Rankings" description="The Prom Cup: Wisconsin high schools compete for the crown. Lock looks, share, and climb your school up the statewide leaderboard." path="/prom-cup" />
      <Trophy className="w-10 h-10 mx-auto text-rosemetal mb-5" />
      <p className="font-label text-[10px] text-rosemetal mb-3">The Prom Cup</p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-none mb-5">Which school reigns?</h1>
      <p className="font-body text-sm text-muted-foreground max-w-lg mx-auto mb-12">
        Every locked look, shared card, and secured dress earns your school points. Watch Wisconsin's schools climb the statewide leaderboard all season long.
      </p>
      <div className="grid sm:grid-cols-3 gap-4 text-left mb-12">
        {[[Crown, "Lock & Secure", "Points for every dress your school locks and makes theirs."], [Sparkles, "Share the Hype", "Bonus points when squads share their looks."], [Trophy, "Crown a Champion", "The top school takes the Prom Cup at season's end."]].map(([Icon, t, d], i) => (
          <div key={i} className="border border-border rounded-sm p-6">
            <Icon className="w-5 h-5 text-rosemetal mb-3" />
            <h3 className="font-display text-xl mb-2">{t}</h3>
            <p className="font-body text-xs text-muted-foreground">{d}</p>
          </div>
        ))}
      </div>
      <Link to="/schools" data-testid="prom-cup-cta" className="bg-ink text-ivory px-8 py-3.5 font-label text-[10px] rounded-sm hover:bg-rosemetal transition-colors">Find Your School</Link>
    </div>
  );
}
